module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-container"
  }, [_c('div', {
    staticClass: "bio-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.checkUrl,
      "alt": "Foto de perfil do usuário"
    }
  }), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-icon-box none"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/trash-outline.svg"),
      "alt": "ícone de lixo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a11b38a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/components/ImageFrame.vue
// module id = 263
// module chunks = 0